<template>
  <div>
    <Gtva ref="gt" @verifySuc="verifySuc" />
    <div class="verifyCode">
      <div class="item">
        <span>验证码</span>
        <input
          v-model="codes"
          class="input-item"
          type="text"
          placeholder="请输入验证码"
          minlength="1"
          maxlength="6"
        >
      </div>
      <a
        v-if="isCode"
        :class="
          (phone && phone.length == 11) ||
            (accountNumber && accountNumber.length == 8)
            ? ''
            : 'gray'"
        @click="getCode"
      >获取验证码</a>
      <a v-else>{{ count }}S</a>
    </div>
    <div class="errMessage">{{ this.errMessage }}</div>
  </div>
</template>

<script>
import Gtva from '@/view/module/Gtva.vue'
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'

export default {
  name: 'VerifyCode',
  components: { Gtva },
  props: ['code', 'phone', 'codeType', 'accountNumber', 'thisPageType'],
  data() {
    // const lastSms = localStorage.getItem("lastSms") || 0;
    // const diff = Math.round((Date.now() - Number(lastSms)) / 1000);
    // let isCode = true;
    // if (diff < 60) isCode = false;
    // else this.startTimer(60 - diff);
    return {
      langs: JSON.parse(process.env.VUE_APP_LANG),
      isCode: true,
      count: '',
      timer: null,
      errMessage: '',
      codes: this.code,
      foreName: ''
    }
  },
  watch: {
    codes: {
      deep: true,
      handler(newValue, oldValue) {
        this.changeCode(newValue)
      }
    }
  },
  mounted() {
    const lastSms = localStorage.getItem('lastSms') || 0
    const diff = Math.round((Date.now() - Number(lastSms)) / 1000)
    let isCode = true
    if (diff < 60) isCode = false
    else this.startTimer(60 - diff)
    this.isCode = isCode
    this.startTimer(60 - diff)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    changeCode(code) {
      this.$emit('changeCode', code)
    },
    // 调用极验
    getCode() {
      if (
        (this.phone && this.phone.length == 11) ||
        (this.accountNumber && this.accountNumber.length == 8)
      ) {
        this.$refs.gt.verify() // 调用极验组件的极验弹框
      }
    },
    startTimer(sec = 60) {
      if (this.timer) return
      this.count = sec
      this.timer = setInterval(() => {
        this.count--
        this.isCode = false
        if (this.count <= 0) {
          this.isCode = true
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    verifySuc(vaParam) {
      const time = 60
      localStorage.setItem('lastSms', Date.now())
      this.startTimer(time)
      // if (!this.timer) {
      //   this.count = time;
      //   this.isCode = false;
      //   this.timer = setInterval(() => {
      //     if (this.count > 0 && this.count <= time) {
      //       this.count--;
      //     } else {
      //       this.isCode = true;
      //       clearInterval(this.timer);
      //       this.timer = null;
      //     }
      //   }, 1000);
      // }
      const customer = {
        mobilePhonePrefix: '86',
        mobilePhone: this.phone,
        customerNumber: this.accountNumber,
        type: this.codeType
      }
      const reaData = this.$qs.stringify(Object.assign(customer, vaParam))
      const headers = {
        visitorId: this.$refs.gt.visitorId,
        lang: this.langs.zn
      }
      this.$bus.$emit('loading', false)
      api.send(reaData, headers).then(res => {
        this.$bus.$emit('loading', true)
        if (res.status == 200) {
          this.codeType == 'RESET_CUSTOMER_PWD'
            ? (this.foreName = '找回密码')
            : (this.foreName = '添加银行卡')

          this.$fireBase.logEvent('phone_code', {
            platform_type:
              this.thisPageType == 'app'
                ? 'app端'
                : this.thisPageType == 'trade'
                  ? 'H5交易'
                  : '用户中心',
            account_type: '真实账户',
            source: this.codeType,
            time: utils.getThisTime(),
            code_type: '短信',
            url: window.location.href
          })
          if (res.data.code == 200) {
            this.errMessage = ''
          } else {
            this.errMessage = res.data.code_desc
            this.isCode = true
            clearInterval(this.timer)
            this.timer = null
          }
        } else {
          this.errMessage = res.data.code_desc
          this.isCode = true
          clearInterval(this.timer)
          this.timer = null
        }
      })
    }
  }
}
</script>
